const baseTimestamp = { seconds: '0', nanos: 0 };
export const Timestamp = {
    fromJSON(object) {
        const message = Object.assign({}, baseTimestamp);
        message.seconds =
            object.seconds !== undefined && object.seconds !== null ? String(object.seconds) : '0';
        message.nanos = object.nanos !== undefined && object.nanos !== null ? Number(object.nanos) : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = message.seconds);
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
};
//# sourceMappingURL=timestamp.js.map